import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import ExpandCollapseButton from '../../UiComponents/buttons/ExpandCollapseButton';
import { TextMuted } from '../../UiComponents/text/StyledText';
import EditableProps from '../table/EditableProps';
import { getSortedGroups } from './tableUtils';
import { actionTypes } from '../utils/installationTypes';
import { 
    DetailsContainer, 
    DeviceContainer, 
    DeviceIconContainer, 
    DeviceList, 
    DeviceMainContainer, 
    IndicatorDot, 
    NameContainer, 
    SummaryContainer, 
    StyledListItem, 
    ListContainer, 
    Flex, 
    ThinDivider, 
    ActionsContainer 
} from '../styling/DeviceStyles';
import { ButtonRowContainer } from '../../panel/ModalStyles';
import NotificationMarker from '../../UiComponents/NotificationMarker';

const EditableList = ({
    objects,
    columns,
    idField,
    getListItemProps,
    saveObject,
    deleteObject,
    sortObjects,
    getActions,
    showNotification
}) => {
    const groups = getSortedGroups(objects, sortObjects);

    const renderObject = (columns, object, index) => (
        <ListItem
            key={index}
            object={object}
            columns={columns}
            idField={idField}
            listItemProps={getListItemProps(object)}
            deleteObject={deleteObject}
            saveObject={saveObject}
            getActions={getActions}
            showNotification={showNotification}
        />
    )

    return <ListContainer>
        <DeviceList>
            {groups.map((group, ix) => <>
                <div key={ix}>
                    {ix > 0 && <ThinDivider />}
                    {group.title && <h4>{group.title}</h4>}
                    {group.objects.map((object, index) => renderObject(columns, object, index))}
                </div>
            </>)}
        </DeviceList>
    </ListContainer>
}

export default EditableList;


const ListItem = ({ object, columns, listItemProps, idField, saveObject, deleteObject, getActions, showNotification }) => {
    const [detailed, setDetailed] = useState(false);

    const changeDetailed = () => {
        setDetailed(!detailed);
    }

    const actions = getActions ? getActions(object).filter(action => !action.hide) : [];

    const Icon = listItemProps.Icon;
    return <StyledListItem>
        <DeviceContainer>
            <NotificationMarker show={showNotification? showNotification(object) : false }/>
            <DeviceMainContainer onClick={changeDetailed} >
                <SummaryContainer>
                    <DeviceIconContainer>
                        <Icon />
                    </DeviceIconContainer>
                    <div>
                        <NameContainer>
                            <div><span>{listItemProps.displayName} </span></div>
                            {listItemProps.displayStatus ? <>
                                <div>
                                    <TextMuted>{listItemProps.displayStatus}</TextMuted>
                                </div>
                            </> : <></>}

                        </NameContainer>
                    </div>
                </SummaryContainer>

                <Flex style={{marginRight: '4px'}}>
                    <div onClick={(e) => e.stopPropagation()}>
                        {renderActions(actions, actionTypes.PRIMARY)}
                    </div>
                    {listItemProps.statusColor ? <>
                        <IndicatorDot>
                            <div style={{ backgroundColor: listItemProps.statusColor }} ></div>
                        </IndicatorDot>
                    </> : <></>}
                    <ExpandCollapseButton showState={detailed} height={30} />
                </Flex>
            </DeviceMainContainer>

            <AnimateHeight duration={300} height={detailed ? 'auto' : 0}>

                <ThinDivider />

                {listItemProps.error ? <>
                    {listItemProps.error}
                </> : <></>}


                <ButtonRowContainer>
                    {renderActions(actions, actionTypes.SECONDARY)}
                </ButtonRowContainer>

                <DetailsContainer>
                    <EditableProps
                        columns={columns}
                        parentObject={object}
                        idField={idField}
                        saveObject={saveObject}
                        deleteObject={deleteObject}
                    />
                </DetailsContainer>

                {listItemProps.renderCustomComponent ? <>
                    <DetailsContainer>
                        {listItemProps.renderCustomComponent(object)}
                    </DetailsContainer>
                </> : <></>}
            </AnimateHeight>
        </DeviceContainer>
    </StyledListItem>
}


const renderActions = (actions, type) => {
    if (actions) {
        return <Flex>
                {actions.filter(action => type !== undefined ? action.type === type : true).map(action => action.render())}
            </Flex>
    } else {
        return <></>;
    }

}